'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultOwnerState = {
  isSubmitting: false,
  hasValue: false,
  isStreaming: false,
  attachmentCount: 0,
  disabled: false
};
const ComposerContext = /*#__PURE__*/React.createContext(_extends({}, defaultOwnerState, {
  value: '',
  setValue: () => {},
  submit: async () => {},
  addAttachment: () => {},
  removeAttachment: () => {},
  attachments: [],
  attachmentConfig: undefined,
  error: null,
  setComposerIsComposing: () => {}
}));
if (process.env.NODE_ENV !== "production") ComposerContext.displayName = "ComposerContext";
export function ComposerContextProvider(props) {
  const {
    children,
    value
  } = props;
  return /*#__PURE__*/_jsx(ComposerContext.Provider, {
    value: value,
    children: children
  });
}
export function useComposerContext() {
  return React.useContext(ComposerContext);
}